import { render, staticRenderFns } from "./SchoolProcurementRank.vue?vue&type=template&id=2283603e&scoped=true&"
import script from "./SchoolProcurementRank.vue?vue&type=script&lang=js&"
export * from "./SchoolProcurementRank.vue?vue&type=script&lang=js&"
import style0 from "./SchoolProcurementRank.vue?vue&type=style&index=0&id=2283603e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283603e",
  null
  
)

export default component.exports